import { AutoStack } from 'components'
import { Stack } from 'forms/FormStack'
import { useCurrentProving } from 'hooks/useCurrentProving'
import { TFunction } from 'i18next'
import _ from 'lodash'
import { Participant, Proving, Vehicle, VehicleType } from 'model'
import moment from 'moment'
import { Checkbox } from 'office-ui-fabric-react'
import React from 'react'
import Timeline, { DateHeader, TimelineHeaders } from 'react-calendar-timeline'
import 'react-calendar-timeline/lib/Timeline.css'
import { useTranslation } from 'react-i18next'
import { Section } from 'views/ProvingDetailsView/Layout'
import {
  getFerries,
  getFlight,
  getGroupObj,
  getParticipant,
  getRentalCar,
  getTrackHotels,
  getVehicle,
  getVehicleTransportationItems,
  GroupObj,
  ItemObj,
} from './index'
import {
  CheckBoxContainer,
  TimelineContainer,
  TimeLineLeftBarGroupColors,
  VerticalSpacer,
} from './TimeLineStyles'

const selectionCategories: string[] = ['participant', 'cars']

const InitTimeLineParticipantItems = (
  proving: Proving,
  selection: string[],
  t: TFunction
) => {
  const groups: GroupObj[] = [] as GroupObj[]
  const items: ItemObj[] = [] as ItemObj[]
  const groupsLookUpDict: { [id: string]: number } = {}
  const vehicleTransportationToDays =
    proving.provingGround && proving.provingGround.vehicleTransportToDays
      ? proving.provingGround.vehicleTransportToDays
      : 0
  const vehicleTransportationFromDays =
    proving.provingGround && proving.provingGround.vehicleTransportFromDays
      ? proving.provingGround.vehicleTransportFromDays
      : 0
  if (selection && selection.includes('participant') && proving.participants) {
    if (proving.participants) {
      const resourceGroupLabel = getGroupObj(
        t(`enum.selectionType.participant`),
        groups.length + 1,
        'MainCategory'
      )
      groups.push(resourceGroupLabel)

      proving.participants.forEach((participant: Participant) => {
        const { participantItem, participantGroup } = getParticipant(
          participant,
          groups.length + 1,
          items.length + 1,
          t
        )
        groups.push(participantGroup)
        items.push(participantItem)

        if (selection.includes('flight')) {
          getFlight(
            participant,
            participantGroup.id,
            items.length + 1,
            t
          ).forEach((flight: ItemObj) => {
            items.push(flight)
          })
        }

        if (selection.includes('trackHotel')) {
          getTrackHotels(
            participant,
            participantGroup.id,
            items.length + 1,
            t
          ).forEach((hotel: ItemObj) => {
            items.push(hotel)
          })
        }

        if (selection.includes('ferry')) {
          getFerries(
            participant,
            participantGroup.id,
            items.length + 1,
            t
          ).forEach((ferry: ItemObj) => {
            items.push(ferry)
          })
        }

        if (selection.includes('rentalCar')) {
          const result = getRentalCar(
            participant,
            participantGroup.id,
            items.length + 1,
            t
          )

          if (result) {
            items.push(result)
          }
        }
      })
    }
  }
  if (selection.includes('cars')) {
    const carsGroupLabel = getGroupObj(
      t(`enum.selectionType.cars`),
      groups.length + 1,
      'MainCategory'
    )
    groups.push(carsGroupLabel)
    proving.vehicles!.forEach((vehicle: Vehicle) => {
      const vehicleGroupTitle =
        vehicle.type === VehicleType.External
          ? t('enum.vehicleType.external')
          : vehicle.model

      const existingGroupValue = groupsLookUpDict[vehicleGroupTitle!]
      const subCategoryExists = existingGroupValue === undefined ? false : true
      if (!subCategoryExists) {
        const vehicleGroupLabel = getGroupObj(
          vehicleGroupTitle!,
          groups.length + 1,
          'SubCategory'
        )
        groups.push(vehicleGroupLabel)
        groupsLookUpDict[`${vehicleGroupLabel.title}`] = vehicleGroupLabel.id
      }

      const { item, group } = getVehicle(
        vehicle,
        groups.length + 1,
        items.length + 1,
        t
      )
      group.stackItems = true
      groupsLookUpDict[`${group.title}`] = group.id
      groups.push(group)

      items.push(item)
      const {
        itemTo,
        itemFrom,
      }: {
        itemTo?: ItemObj
        itemFrom?: ItemObj
      } = getVehicleTransportationItems(
        item,
        items.length,
        group.id,
        vehicleTransportationToDays,
        vehicleTransportationFromDays
      )
      if (itemTo) {
        items.push(itemTo)
      }
      if (itemFrom) {
        items.push(itemFrom)
      }
    })
  }

  return { groups, items }
}

export interface TimeLineProps {
  label?: string
}

export const ResourceManager: React.FC<TimeLineProps> = ({
  label,
}: TimeLineProps) => {
  const { t } = useTranslation()
  const [proving] = useCurrentProving()
  const selectionTypes: string[] = ['rentalCar']
  if (
    proving &&
    proving.provingGround &&
    proving.provingGround.hideHotels === false
  ) {
    selectionTypes.push('trackHotel')
  }
  if (
    proving &&
    proving.provingGround &&
    proving.provingGround.hideFerryConnection === false
  ) {
    selectionTypes.push('ferry')
  }
  if (
    proving &&
    proving.provingGround &&
    proving.provingGround.hideFlight === false
  ) {
    selectionTypes.push('flight')
  }

  const [selection, setselection] = React.useState<string[]>([
    'participant',
    'cars',
    'flight',
    'trackHotel',
    'ferry',
    'rentalCar',
  ] as string[])

  const ExtendOrTrimArray = (array: string[], item: string): string[] => {
    const exist = _.findIndex(array, (i: string) => {
      return i === item
    })

    if (exist !== -1) {
      _.remove(array, (i: string) => {
        return i === item
      })
    } else {
      array.push(item)
    }
    return array.slice()
  }
  const CheckSelectedIn = (array: string[], item: string): boolean => {
    return (
      _.findIndex(array, (i: string) => {
        return i === item
      }) > -1
    )
  }

  const groupRenderer = (item: any) => {
    return (
      <div
        style={{
          backgroundColor: TimeLineLeftBarGroupColors[item.group.type]
            ? TimeLineLeftBarGroupColors[item.group.type]
            : '#FFF',
          textAlign: 'center',
          margin: '0 -4px',
        }}
      >
        <span title={item.group.title} className="title">
          {item.group.title}
        </span>
      </div>
    )
  }

  const { groups, items } = InitTimeLineParticipantItems(proving, selection, t)
  return (
    <>
      <Stack horizontal={true}>
        <Section label={'Buchungen'}>
          <AutoStack horizontal={true}>
            {selectionCategories.map((category: any, i: number) => {
              return (
                <CheckBoxContainer key={i}>
                  <Checkbox
                    label={t(`enum.selectionType.${category}`)}
                    checked={CheckSelectedIn(selection, category)}
                    onChange={() => {
                      setselection(ExtendOrTrimArray(selection, category))
                    }}
                  />
                </CheckBoxContainer>
              )
            })}
          </AutoStack>
        </Section>
        <VerticalSpacer />
        <Section label={'Daten Anzeigen'}>
          <AutoStack horizontal={true}>
            {selectionTypes.map((type: any, i: number) => {
              return (
                <CheckBoxContainer key={i}>
                  <Checkbox
                    label={t(`enum.dataSelection.${type}`)}
                    checked={CheckSelectedIn(selection, type)}
                    onChange={() => {
                      setselection(ExtendOrTrimArray(selection, type))
                    }}
                  />
                </CheckBoxContainer>
              )
            })}
          </AutoStack>
        </Section>
      </Stack>

      {groups.length > 0 && (
        <Section label={t(`enum.selectionType.bookings`)}>
          <TimelineContainer>
            <Timeline
              minZoom={86400}
              maxZoom={365.24 * 86400 * 1000}
              groupRenderer={groupRenderer}
              timeSteps={{
                second: 0,
                minute: 0,
                hour: 1,
                day: 1,
                month: 1,
                year: 1,
              }}
              groups={groups}
              items={items}
              defaultTimeStart={moment(proving.dateFrom)}
              defaultTimeEnd={moment(proving.dateTo)}
            >
              <TimelineHeaders>
                <DateHeader unit="primaryHeader" />
                <DateHeader
                  unit="week"
                  labelFormat={(time) => {
                    const weeknumber = moment(time[0]).week()
                    return `KW ${weeknumber}`
                  }}
                />
                <DateHeader unit="day" />
              </TimelineHeaders>
            </Timeline>
          </TimelineContainer>
        </Section>
      )}
    </>
  )
}

export default ResourceManager
